<template>
  <div class="tables" style="width: 100%">
    <el-table
        class="tableAuto"
        v-loading="isLoading"
        :data="tableData"
        style="width: 100%"
        :cell-style="rowClassName"
        :header-cell-style="headerClassName"
        @cell-mouse-leave="clearVisiblePopover"
    >
      <el-table-column
          v-for="(item, index) in targetMaps"
          :key="item.key"
          :label="item.key"
          :prop="item.value"
          label="Date"

          :width="handleClickSelectWidth(item)"
      >
        <template v-if="item.value==='remark'" #default="scope">
          <el-icon
              :color="scope.row.remark ? '#40a9ff' : '#dddddd'">
            <el-tooltip
                v-if="scope.row.remark"
                class="box-item"
                :content="scope.row.remark"
                placement="right"
                popper-class="tips_width"
            >
              <Memo/>
            </el-tooltip>
            <Memo v-else/>
          </el-icon>
        </template>
        <template v-else-if="item.value==='name'" #default="{row}">
          <div style="display: flex;align-items: center;">
            <el-icon v-if="row?.isMain" style="margin-right: 5px;">
              <User/>
            </el-icon>
            <div :ref="ref => (refMap[`${row.email}name`] = ref)"
                 @mouseover.stop="handleRef(refMap[`${row.email}name`], row, 1)"
                 class="over_normal"
                 v-if=" getTextLength(row.name) > sizeMaxNumber"
                 :key="row.name">
              {{
                getTextLength(row.name) > sizeMaxNumber ? formatText(row.name, sizeMaxNumber) : row.name
              }}
            </div>
            <div v-else class="over_normal">
              {{ row.name }}
            </div>
          </div>
        </template>
        <template v-else-if="item.value==='nickName'" #default="{row}">
          <div :ref="ref => (refMap[`${row.email}nickName`] = ref)"
               @mouseover.stop="handleRef(refMap[`${row.email}nickName`], row, 2)"
               class="over_normal"
               v-if=" getTextLength(row.nickName) > sizeMaxNumber"
               :key="row.nickName">
            {{
              getTextLength(row.nickName) > sizeMaxNumber ? formatText(row.nickName, sizeMaxNumber) : row.nickName
            }}
          </div>
          <div v-else class="over_normal">
            {{ row.nickName }}
          </div>
        </template>
        <template v-else-if="item.value==='email'" #default="{row}">
          <div :ref="ref => (refMap[`${row.email}email`] = ref)"
               @mouseover.stop="handleRef(refMap[`${row.email}email`], row, 3)"
               class="over_normal"
               v-if=" getTextLength(row.email) > sizeMaxNumber"
               :key="row.email">
            {{
              getTextLength(row.email) > sizeMaxNumber ? formatText(row.email, sizeMaxNumber) : row.email
            }}
          </div>
          <div v-else class="over_normal">
            {{ row.email }}
          </div>
        </template>
        <template v-else-if="item.value==='departName'" #default="{row}">
          <div :ref="ref => (refMap[`${row.email}departName`] = ref)"
               @mouseover.stop="handleRef(refMap[`${row.email}departName`], row, 4)"
               class="over_normal"
               v-if=" getTextLength(row.departName) > sizeMaxNumber"
               :key="row.departName">
            {{
              getTextLength(row.departName) > sizeMaxNumber ? formatText(row.departName, sizeMaxNumber) : row.departName
            }}
          </div>
          <div v-else class="over_normal">
            {{ row.departName }}
          </div>
        </template>
        <template v-else-if="item.value==='post'" #default="{row}">
          <div :ref="ref => (refMap[`${row.email}post`] = ref)"
               @mouseover.stop="handleRef(refMap[`${row.email}post`], row, 5)"
               class="over_normal"
               v-if=" getTextLength(row.post) > sizeMaxNumber"
               :key="row.post">
            {{
              getTextLength(row.post) > sizeMaxNumber ? formatText(row.post, sizeMaxNumber) : row.post
            }}
          </div>
          <div v-else class="over_normal">
            {{ row.post }}
          </div>
        </template>
        <template v-else-if="item.value==='contactPhone'" #default="{row}">
          <div :ref="ref => (refMap[`${row.email}contactPhone`] = ref)"
               @mouseover.stop="handleRef(refMap[`${row.email}contactPhone`], row, 6)"
               class="over_normal"
               v-if=" getTextLength(row.contactPhone) > sizeMaxNumber"
               :key="row.contactPhone">
            {{
              getTextLength(row.contactPhone) > sizeMaxNumber ? formatText(row.contactPhone, sizeMaxNumber) : row.contactPhone
            }}
          </div>
          <div v-else class="over_normal">
            {{ row.contactPhone }}
          </div>
        </template>
        <template v-else-if="item.value==='birthday'" #default="{row}">
          <div>
            {{ row.birthday ? row.birthday.split(" ")[0] : "" }}
          </div>
        </template>
        <template v-else-if="item.value==='createTime'" #default="{row}">
          <div :ref="ref => (refMap[`${row.email}createTime`] = ref)"
               @mouseover.stop="handleRef(refMap[`${row.email}createTime`], row, 7)"
               class="over_normal"
               v-if=" getTextLength(row.createTime) > sizeMaxNumber"
               :key="row.createTime">
            {{
              getTextLength(row.createTime) > sizeMaxNumber ? formatText(row.createTime, sizeMaxNumber) : row.createTime
            }}
          </div>
          <div v-else class="over_normal">
            {{ row.createTime }}
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.operate')" width="150">
        <template #default="{ row, column, $index }">
          <el-button size="small" type="primary" link @click="handleClickHistroy(row)">{{
              $t('common.contact.record')
            }}
          </el-button>
          <el-button
              type="primary"
              link
              size="small"
              @click="clickEdit(row, column, $index)"
          >{{ $t('common.edit') }}
          </el-button
          >
          <ConfirmDeletePopover
              :visible="row.popoverVisible"
              :width="168"
              :message="$t('sys.message.ask.contect.delete')"
              @update:visible="(value) => (row.popoverVisible = value)"
              @confirm:delete="handleDelete(row, column, $index)"
          >
            <template #settings>
              <el-button size="small" type="danger" link @click="handleDeleteT(row, column, $index)">
                {{ $t('common.delete') }}
              </el-button>
            </template>
          </ConfirmDeletePopover>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
      </template>
    </el-table>
    <div class="pages" style="margin-top: 15px">
      <el-pagination
          v-model:current-page="pageNo"
          v-model:page-size="pageSize"
          v-if="total"
          layout="total, prev, pager, next"
          :total="total"
          size="small"
          @current-change="handleCurrentChange"
      />
    </div>
  </div>
  <el-popover
      v-model:visible="visiblePopover"
      :virtual-ref="tempRef"
      virtual-triggering
      :popper-style="{ minWidth: '60px', width: 'auto' }"
      trigger="hover"
      effect="dark"
      :show-after="1200"
  >
    <template v-if="popoverType === 1">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover.name }}
      </div>
    </template>
    <template v-if="popoverType === 2">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover.nickName }}
      </div>
    </template>
    <template v-if="popoverType === 3">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover.email }}
      </div>
    </template>
    <template v-if="popoverType === 4">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover.departName }}
      </div>
    </template>
    <template v-if="popoverType === 5">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover.post }}
      </div>
    </template>
    <template v-if="popoverType === 6">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover?.contactPhone }}
      </div>
    </template>
    <template v-if="popoverType === 7">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover?.createTime }}
      </div>
    </template>
  </el-popover>

</template>
<script setup>
import {ref, computed, reactive, onMounted, nextTick, defineEmits} from "vue";
import {useRouter} from "vue-router";
import {useStore} from "vuex";

import ConfirmDeletePopover from "@/components/ConfirmDeletePopover.vue";
import {emptyUrl, POPOVER_DELAY_TIME} from "@/utils/statusParams";
import {i18n} from "@/lang";
import {ElTable} from "element-plus";
import {Memo, User} from "@element-plus/icons-vue";
import {flexWidth} from "@/utils/tableWidth";
import {getTextLength} from "@/utils/util";
import {formatText} from "../../../utils/util";
import {debouncePlus} from "@/utils/mylodash";
import sessionStore from "@/utils/sessionStore";

const router = useRouter();
const store = useStore();
const tableData = computed(() => store.state.customer.contactList);
const pageSize = computed(() => store.state.customer.contactPage.pageSize);
const pageNo = computed(() => store.state.customer.contactPage.pageNo);
const total = computed(() => store.state.customer.contactPage.total);
const contactLoading = computed(() => store.state.customer.contactLoading);

const emit = defineEmits(["clickEdit"]);

const handleCurrentChange = (page) => {
  store.commit("customer/setContactPage", {
    total: total.value,
    pageNo: page,
    pageSize: pageSize.value,
  });
  store.dispatch("customer/getContactList");
};

const targetMaps = [
  {key: i18n.global.t('common.name'), value: "name"},
  {key: i18n.global.t('common.user.nick1'), value: "nickName"},
  {key: i18n.global.t('common.emailbox'), value: "email"},
  {key: i18n.global.t('common.department'), value: "departName"},
  {key: i18n.global.t('common.position'), value: "post"},
  {key: i18n.global.t('common.contact.phone'), value: "contactPhone"},
  {key: i18n.global.t('common.birthday'), value: "birthday"},
  {key: i18n.global.t('common.record.time'), value: "createTime"},
  {key: i18n.global.t('common.remark'), value: "remark"},
];

const middleValueWidth = ref(160)
// 字数大致限制
const sizeMaxNumber = ref(13)
const handleClickSelectWidth = (item) => {
  if (item.value === 'birthday') {
    return 100
  } else if (item.value === 'createTime') {
    return 150
  } else if (item.value === 'remark') {
    return 50
  }
  // if (item.value === "name") {
  //   return flexWidth('name', tableData.value, i18n.global.t('common.name')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('name', tableData.value, i18n.global.t('common.name')) + 20
  // } else if (item.value === 'nickName') {
  //   return flexWidth('nickName', tableData.value, i18n.global.t('common.user.nick1')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('nickName', tableData.value, i18n.global.t('common.user.nick1')) + 20
  // } else if (item.value === 'email') {
  //   return flexWidth('email', tableData.value, i18n.global.t('common.emailbox')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('email', tableData.value, i18n.global.t('common.emailbox')) + 20
  // } else if (item.value === 'departName') {
  //   return flexWidth('departName', tableData.value, i18n.global.t('common.department')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('departName', tableData.value, i18n.global.t('common.department')) + 20
  // } else if (item.value === 'post') {
  //   return flexWidth('post', tableData.value, i18n.global.t('common.position')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('post', tableData.value, i18n.global.t('common.position')) + 20
  // } else if (item.value === 'contactPhone') {
  //   return 160
  // } else if (item.value === 'birthday') {
  //   return 160
  // } else if (item.value === 'createTime') {
  //   return flexWidth('createTime', tableData.value, i18n.global.t('common.record.time')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('createTime', tableData.value, i18n.global.t('common.record.time')) + 20
  // }
}

// const handleClickSelectMinWidth = (item, type) => {
//   if (item.value === 'remark') {
//     return 80
//   } else {
//     return 160
//   }
// }

// el-popover 优化
const refMap = ref({})
const tempRef = ref()
const visiblePopover = ref(false)
// -1-字句审核 0-整句审核 1-日志查看
const popoverType = ref(0)
const activeItemElpopover = ref(null)

const handleRef = debouncePlus((ref, item, type) => {
  console.log('refMap', refMap.value)
  tempRef.value = ref
  popoverType.value = type
  activeItemElpopover.value = item;
  if (type === 1) {
    // ...业务逻辑1
  } else {
    // ...业务逻辑2、3
  }
  visiblePopover.value = true
}, POPOVER_DELAY_TIME)


const isLoading = ref(false)
onMounted(async () => {
  const customerId = router.currentRoute.value.params.userId;
  sessionStore.set("customerId", customerId);
  isLoading.value = true
  await store.dispatch("customer/getContactList");
  isLoading.value = false
});

const popoverVisible = ref(false);
const handleDelete = async (row, column, $index) => {
  await store.dispatch("customer/deleteContact", {id: row.id});
  await store.dispatch("customer/getContactList");
  row.popoverVisible = false;
};
const handleDeleteT = async (row, column, $index) => {
  row.popoverVisible = true;
}

const handleClickHistroy = (row) => {
  emit('clickHistory', {history: true, item: row})
}

const clickEdit = (row, column, $index) => {
  emit("clickEdit", {row, column, $index});
};


const rowClassName = ({row, column, rowIndex, columnIndex}) => {
  // console.log(row, columnIndex)
  if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 9) {
    return {textAlign: 'left'}
  } else {
    return {textAlign: 'center'}
  }
}

const headerClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 9) {
    return {'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  } else {
    return {'text-align': 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  }
}

const clearVisiblePopover = () => {
  setTimeout(() => {
    visiblePopover.value = false
  }, POPOVER_DELAY_TIME + 10)
}

</script>
<style lang="less" scoped>
@import "../../../less/page.less";

:deep(.el-empty__image img) {
  width: 54% !important;
}

:deep(.el-table__header) {
  width: 100% !important;
}

:deep(.el-table__body) {
  width: 100% !important;
}

.tableAuto.el-table .cell {
  white-space: nowrap;
}

:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}
</style>
